import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/query-client';
import { routeTree } from './routes';
import './index.css';

// Create the router instance
const router = createRouter({
  routeTree,
  defaultErrorComponent: ({ error }) => (
    <div style={{ padding: '2rem', color: '#ff6b6b', fontFamily: 'monospace' }}>
      <h2>Route Error</h2>
      <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
        {error instanceof Error ? `${error.message}\n\n${error.stack}` : String(error)}
      </pre>
    </div>
  ),
});

// Register router for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Render the app
const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>
);
